document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuLinks = document.querySelectorAll('#pdw-mobile-menu a[href^="#"]');
    const mobileMenu = document.getElementById('pdw-mobile-menu');
    const closeTrigger = document.querySelector('.pdw-mobile-menu-close');

    if (mobileMenuLinks.length > 0 && mobileMenu) {
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (closeTrigger) {
                    closeTrigger.click();
                }
                mobileMenu.classList.remove('is-open');
                document.body.classList.remove('menu-open');
            });
        });
    }
});